import { render } from "./MarcacaoImagem.vue?vue&type=template&id=97bbc142"
import script from "./MarcacaoImagem.vue?vue&type=script&lang=js"
export * from "./MarcacaoImagem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__